import { atom } from 'jotai';

import { type ConfigType } from '../../types/config';

const defaultConfig = {
    nodeEnv: '',
    appId: '',
    contextRoot: '',
    apiEndpointPath: '',
    metricsDomain: '',
    dsCdnPath: '',
};

export const appConfigAtom = atom<ConfigType>(defaultConfig);
